const NAME = 'SENDBIRD';

export const getSendbirdUsers = (store) => store[NAME].users;
